import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { forgotPasswordApi } from "../api/forgotPasswordApi";

/**
 * hooks for forgot password
 */
export default function useForgotPassword() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [errors, setErrors] = useState({
    email: email.trim() === "",
  });

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    await forgotPasswordApi(email);
  };

  return {
    email,
    disabledSubmit: errors.email,
    setErrors,
    handleSubmit,
    setEmail,
  };
}
